import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW1309Model } from './kymw1309.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../../../src/app/commons/kymw00/pless-dialog-service-sub';
import { FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { KYMW1309InputModel } from './vo/kymw1309-input.model';
import { CodeComboBoxComponent } from '../../../../../src/app/commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { KYMW1309OutputModel } from './vo/kymw1309-output.model';
import { KYMW1309GetPromotionGoodsInfoModel } from './vo/kymw1309-get-promotion-goods-info.model';
import { GetPromotionGoodsInfoService } from './api-service/get-promotion-goods-info.service';

/**
 * バンドルミックスマッチ検索画面を管理するクラス
 *
 * @export KYMW1309Component
 * @class KYMW1309Component
 */
@Component({
  selector: 'app-kymw1309',
  templateUrl: 'kymw1309.component.html',
  styleUrls: ['kymw1309.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1309Component extends PlessViewHelperSub implements OnInit {

  // バンドルミックスマッチ検索画面用インプットVO
  private inputVO: KYMW1309InputModel;

  kymw1309Model: KYMW1309Model = new KYMW1309Model();

  @ViewChild('dtg_PromotionGoods', { static: true }) dtg_PromotionGoods: FlexGrid;
  @ViewChild('cmb_PromotionDiv', { static: true }) cmb_PromotionDiv: CodeComboBoxComponent;
  @ViewChild('btn_Search', { static: true }) public btn_Search: ElementRef;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;
  selfManage: KYMW1309Model;
  setKYMW1309Parameter: Function;

  /**
   *Creates an instance of KYMW1309Component.
   * @param {PlessDialogService} dialogService
   * @memberof KYMW1309Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getPromotionGoodsInfoService: GetPromotionGoodsInfoService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  // eslint-disable-next-line
  public ngOnInit(): void {
    this.componentName = 'KYMW1309';
    this.dtg_PromotionGoods.columnHeaders.rows[0].height = 70;
    this.kymw1309Model.kymw1309Component = this;
    this.selfManage = this.kymw1309Model;
    this.dtg_PromotionGoods.selectionMode = SelectionMode.Row;

    // 受注コード
    this.kymw1309Model.orderCode = this.inputVO.orderCode;

    // 媒体区分
    this.kymw1309Model.mediumType = this.inputVO.mediumType;

    // プロモーション区分
    this.kymw1309Model.promotionDiv = this.inputVO.promotionDiv;

    // プロモーション名称
    this.kymw1309Model.promotionName = this.inputVO.promotionName;

    // 会員生協
    this.kymw1309Model.coop = this.inputVO.coopCode;

    // Ｐコード
    this.kymw1309Model.pCode = this.inputVO.pCode;

    // 部門コード
    this.kymw1309Model.classCode = this.inputVO.classCode;

    // プロモーション情報
    this.kymw1309Model.promotionInfo = new Array<any>();

    this.cmb_PromotionDiv.elementRef.nativeElement.focus();

    this.dtg_PromotionGoods.itemsSourceChanged.addHandler(() => {
      this.dtg_PromotionGoods.select(-1, -1);
    });

  }

  /**
   * 検索ボタン_クリック時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSearch_CLICKHandler(event: Event): void {

    const vo: KYMW1309OutputModel = new KYMW1309OutputModel();

    // 処理区分
    vo.accessDiv = '1';

    // プロモーション区分
    vo.promotionDiv = this.kymw1309Model.promotionDiv;

    // プロモーション名称
    vo.promotionName = this.kymw1309Model.promotionName;

    // 生協コード
    vo.coopCode = this.kymw1309Model.coop;

    // Ｐコード
    vo.pCode = this.kymw1309Model.pCode;

    // 部門コード
    vo.classCode = this.kymw1309Model.classCode;

    // 呼出元画面に検索条件,選択行を返却する
    this.setKYMW1309Parameter(vo);

    // プロモーション商品情報取得要求をサーバに送信
    this.getPromotionGoodsInfoService.execute(this.kymw1309Model, this.createGetPromotionGoodsInfoVO());
  }

  /**
   * 選択ボタン_クリック時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSelect_CLICKHandler(event: Event): void {

    // 未選択時、処理中断
    if (PlessViewUtilsSub.isEmptyArray(this.dtg_PromotionGoods.selectedItems)) {
      return;
    }

    const vo: KYMW1309OutputModel = new KYMW1309OutputModel();

    // 処理区分
    vo.accessDiv = '2';

    // プロモーションＮＯ
    vo.promotionNo = this.dtg_PromotionGoods.selectedItems[0].promotionNo;

    // 呼出元画面に検索条件,選択行を返却する
    this.setKYMW1309Parameter(vo);

    // 閉じる
    this.closeFunction();
  }

  /*--------------------------------------------------------------------------------------------
  /* util area
  /*--------------------------------------------------------------------------------------------*/

  /**
   * プロモーション商品情報取得リクエスト用VO設定
   *
   * @return GetPromotionGoodsInfoVO
   */
  private createGetPromotionGoodsInfoVO(): KYMW1309GetPromotionGoodsInfoModel {

    const vo: KYMW1309GetPromotionGoodsInfoModel = new KYMW1309GetPromotionGoodsInfoModel();

    // 受注コード
    vo.orderCode = this.kymw1309Model.orderCode;

    // 媒体区分
    vo.mediumType = this.kymw1309Model.mediumType;

    // プロモーションＮＯ
    vo.promotionNo = '';

    // プロモーション区分
    vo.promotionDiv = this.kymw1309Model.promotionDiv;

    // プロモーション名称
    vo.promotionName = this.kymw1309Model.promotionName;

    // 生協コード
    vo.coopCode = this.kymw1309Model.coop;

    // Ｐコード
    vo.pCode = this.kymw1309Model.pCode;

    // 部門コード
    vo.classCode = this.kymw1309Model.classCode;

    return vo;
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW1309Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = param;
  }
}
